import {
  CalculatorsStudentLoanStep1FormFields,
  CalculatorsStudentLoanStep2FormFields
} from '../../../../../@types/features/calculators';
import { calculatorStudentLoanStep1FormFields } from '../config/calculator-student-loan-step-1-form-fields';
import { calculatorStudentLoanStep2FormFields } from '../config/calculator-student-loan-step-2-form-fields';
import { ApiMaximumMortgageByIncomeRequest } from '../../../../../@types/shared/api';
import { utilStringToNumber } from '../../../../../utils';

const getDefaultValuesStep1 = (): CalculatorsStudentLoanStep1FormFields => {
  return {
    studentDebtAmount: calculatorStudentLoanStep1FormFields.studentDebtAmount.defaultValue,
    withPartner: calculatorStudentLoanStep1FormFields.withPartner.defaultValue,
    partnerStudentDebtAmount:
      calculatorStudentLoanStep1FormFields.partnerStudentDebtAmount.defaultValue
  };
};

const getDefaultValuesStep2 = (): CalculatorsStudentLoanStep2FormFields => {
  return {
    applicantAge: calculatorStudentLoanStep2FormFields.applicantAge.defaultValue,
    applicantYearlyIncome: calculatorStudentLoanStep2FormFields.applicantYearlyIncome.defaultValue,
    partnerYearlyIncome: calculatorStudentLoanStep2FormFields.partnerYearlyIncome.defaultValue,
    partnerAge: calculatorStudentLoanStep2FormFields.partnerAge.defaultValue
  };
};

const getMaximumMortgageByIncomeRequestBody = (
  formData: Record<keyof CalculatorsStudentLoanStep2FormFields, string>,
  form: CalculatorsStudentLoanStep1FormFields,
  interest: number
): ApiMaximumMortgageByIncomeRequest => {
  const { studentDebtAmount, partnerStudentDebtAmount, withPartner } = form;

  const applicantLoan = calculateStudentDebt(utilStringToNumber(studentDebtAmount), interest);

  const partnerLoan =
    withPartner === 'true'
      ? calculateStudentDebt(utilStringToNumber(partnerStudentDebtAmount), interest)
      : 0;

  const educationLoans = applicantLoan + partnerLoan;
  const body: ApiMaximumMortgageByIncomeRequest = {
    mortgageType: 4,
    applicant: {
      age: parseInt(formData.applicantAge),
      yearlyIncome: parseInt(formData.applicantYearlyIncome)
    },
    educationLoans,
    fixedInterestPeriod: 10
  };

  if (withPartner === 'true') {
    body.partner = {
      age: parseInt(formData.partnerAge),
      yearlyIncome: parseInt(formData.partnerYearlyIncome)
    };
  }

  return body;
};

/*
const getStudentDebtMultiplier = (interest: number): number => {
  if (interest < 2.0) {
    return 1.05;
  } else if (interest < 2.5) {
    return 1.1;
  } else if (interest < 3.0) {
    return 1.15;
  } else if (interest < 3.5) {
    return 1.2;
  } else if (interest < 4.0) {
    return 1.2;
  } else if (interest < 4.5) {
    return 1.25;
  } else if (interest < 5.0) {
    return 1.3;
  } else if (interest < 5.5) {
    return 1.3;
  } else if (interest < 6.0) {
    return 1.35;
  } else {
    return 1.4;
  }
};
*/
const calculateStudentDebt = (studentDebtAmount: number, interest: number): number => {
  if (isNaN(studentDebtAmount) || isNaN(interest)) {
    return 0;
  }

  //const multiplier = getStudentDebtMultiplier(interest);
  return Math.round(studentDebtAmount);
};

export { getDefaultValuesStep1, getDefaultValuesStep2, getMaximumMortgageByIncomeRequestBody };
